module.exports = {
  tbmobile: {
    title: "CVS pharmacy",
    traceability: "Goods Traceability",
    details: "View Details",
    medicinebox: "Medicine Box",
    checkbox: "Check All Box",
    binding: "User Binding",
    relatives: "My Relatives",
    doctor: "My Doctor",
    catalog: "Catalog",
    content: "Content",
    retrieval: "Retrieval",
    captionRetrieval: "Caption Retrieval",
    noCaption: "No Relevant Caption",
    loading: "Loading",
    video: "Medical Play"
  },
  toorigins: {
    title: "CVS pharmacy",
    traceCode: "Trace Code：81325160499913080328",
    details: "details>",
    validation: "Validation",
    normal: "Normal",
    productionDate: "Production Date",
    expiryDate: "Expiry Date",
    usageAnddosage: "Usage and Dosage",
    usage: "Orally. 6 tablets at a time, 2 times a day",
    scanRecord: "Scan Record",
    scanDetails: "details",
    scanResult: "It's normal within 5 times scan",
    company: "Yunnan Baiyao Group Limited by Share Ltd"
  },
  medBox: {
    title: "Medicine Box",
    CVS: "CVS pharmacy",
    VC: "Vitamin C Yinqiao Tablets",
    huanglian: "Huanglianshangqing tablets",
    chaihu: "XiaoChaihu granule",
    productionbatch: "Production Batch",
    productionDate: "Production Date",
    expiryDate: "Expiry Date",
    usageAnddosage: "Usage and Dosage",
    usage: "Orally. 6 tablets at a time, 2 times a day",
  },
  myDoc: {
    title: "My Doctor",
    doc1: "张智伟",
    skill: "小儿心脏病专家",
    company: "广东省人民医院心血管病研究所"
  },
  userbind: {
    title: "User Binding",
    phone: "Phone Number",
    tips: "Please input your phone number",
    button: "Bind users and send a reminder",
    loading: "Sending...",
    success: "Successful send",
    failure: "Fail, please try again later"
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en.js